// Демо-данные окна «Дашборд» (Dashboard) для главной Hub.
// Пустое рабочее пространство по умолчанию: этапы жизненного цикла, вкладки контактов,
// участники команды и подсказки. demoCount/demoValue — числа, которые появляются
// при включённом переключателе «Демо-данные», чтобы окно не оставалось пустым.

import { t } from "@/lib/i18n";

export const dashboardMeta = {
  plan: "Growth Plan",
  trialDays: 6,
  trialEnds: t("3 ноября 2026"),
  timeZone: "Europe/Rome (GMT+01:00)",
};

export type DashMetric = { icon: string; label: string; value: string; demoValue: string };

export type DashStage = {
  id: string;
  name: string;
  icon: string;
  count: number;
  demoCount: number;
  share: string;
  demoShare: string;
  metrics: DashMetric[];
};

export const lifecycleCards: DashStage[] = [
  {
    id: "new",
    name: t("Новый лид"),
    icon: "ri-user-add-line",
    count: 0,
    demoCount: 12,
    share: "0.00%",
    demoShare: "34.29%",
    metrics: [
      { icon: "ri-user-line", label: t("В работе"), value: "0", demoValue: "5" },
      { icon: "ri-time-line", label: t("Ждут ответа"), value: "0", demoValue: "3" },
      { icon: "ri-alarm-warning-line", label: t("Просрочено"), value: "0", demoValue: "1" },
    ],
  },
  {
    id: "hot",
    name: t("Горячий лид"),
    icon: "ri-fire-line",
    count: 0,
    demoCount: 8,
    share: "0.00%",
    demoShare: "22.86%",
    metrics: [
      { icon: "ri-user-line", label: t("В работе"), value: "0", demoValue: "4" },
      { icon: "ri-time-line", label: t("Ждут ответа"), value: "0", demoValue: "2" },
      { icon: "ri-alarm-warning-line", label: t("Просрочено"), value: "0", demoValue: "0" },
    ],
  },
  {
    id: "payment",
    name: t("Оплата"),
    icon: "ri-hand-coin-line",
    count: 0,
    demoCount: 6,
    share: "0.00%",
    demoShare: "17.14%",
    metrics: [
      { icon: "ri-user-line", label: t("В работе"), value: "0", demoValue: "3" },
      { icon: "ri-time-line", label: t("Ждут ответа"), value: "0", demoValue: "1" },
      { icon: "ri-alarm-warning-line", label: t("Просрочено"), value: "0", demoValue: "0" },
    ],
  },
  {
    id: "customer",
    name: t("Клиент"),
    icon: "ri-vip-crown-line",
    count: 0,
    demoCount: 9,
    share: "0.00%",
    demoShare: "25.71%",
    metrics: [
      { icon: "ri-user-line", label: t("В работе"), value: "0", demoValue: "2" },
      { icon: "ri-time-line", label: t("Ждут ответа"), value: "0", demoValue: "1" },
      { icon: "ri-alarm-warning-line", label: t("Просрочено"), value: "0", demoValue: "0" },
    ],
  },
];

export const contactTabs = [
  { id: "open", label: t("Открытые") },
  { id: "assigned", label: t("Назначенные") },
  { id: "unassigned", label: t("Неназначенные") },
];

export type DashContact = {
  id: string;
  name: string;
  initials: string;
  channel: string;
  channelIcon: string;
  stage: string;
  assignee: string;
  unread: number;
  last: string;
};

export const demoContacts: DashContact[] = [
  {
    id: "c-1",
    name: t("Анна Ковалёва"),
    initials: t("АК"),
    channel: "WhatsApp",
    channelIcon: "ri-whatsapp-line",
    stage: t("Новый лид"),
    assignee: t("Виктор Ярутов"),
    unread: 2,
    last: t("2 мин назад"),
  },
  {
    id: "c-2",
    name: t("Игорь Дёмин"),
    initials: t("ИД"),
    channel: "Telegram",
    channelIcon: "ri-telegram-line",
    stage: t("Горячий лид"),
    assignee: t("Игорь Дёмин"),
    unread: 0,
    last: t("14 мин назад"),
  },
  {
    id: "c-3",
    name: t("Марина Гусева"),
    initials: t("МГ"),
    channel: "WhatsApp",
    channelIcon: "ri-whatsapp-line",
    stage: t("Оплата"),
    assignee: "",
    unread: 1,
    last: t("26 мин назад"),
  },
  {
    id: "c-4",
    name: t("Павел Ким"),
    initials: t("ПК"),
    channel: t("Почта"),
    channelIcon: "ri-mail-line",
    stage: t("Новый лид"),
    assignee: "",
    unread: 3,
    last: t("41 мин назад"),
  },
  {
    id: "c-5",
    name: t("Ольга Смирнова"),
    initials: t("ОС"),
    channel: "Telegram",
    channelIcon: "ri-telegram-line",
    stage: t("Клиент"),
    assignee: t("Алина Гусева"),
    unread: 0,
    last: t("1 ч назад"),
  },
  {
    id: "c-6",
    name: t("Сергей Лебедев"),
    initials: t("СЛ"),
    channel: "WhatsApp",
    channelIcon: "ri-whatsapp-line",
    stage: t("Горячий лид"),
    assignee: t("Виктор Ярутов"),
    unread: 1,
    last: t("2 ч назад"),
  },
];

export type DashMember = {
  id: string;
  name: string;
  initials: string;
  role: string;
  online: boolean;
  since: string;
  demoContacts: number;
};

// Виктор — владелец: он есть в рабочем пространстве с самого начала
export const dashboardTeam: DashMember[] = [
  {
    id: "u-1",
    name: t("Виктор Ярутов"),
    initials: t("ВЯ"),
    role: t("Владелец"),
    online: true,
    since: t("Вчера в 22:45"),
    demoContacts: 2,
  },
  {
    id: "u-2",
    name: t("Алина Гусева"),
    initials: t("АГ"),
    role: t("Менеджер"),
    online: true,
    since: t("Сегодня в 09:12"),
    demoContacts: 1,
  },
  {
    id: "u-3",
    name: t("Игорь Дёмин"),
    initials: t("ИД"),
    role: t("Агент"),
    online: false,
    since: t("Вчера в 18:04"),
    demoContacts: 1,
  },
];

export const statusFilters = [
  { id: "all", label: t("Все статусы") },
  { id: "online", label: t("Онлайн") },
  { id: "offline", label: t("Не в сети") },
];

export const dashboardHints = [
  {
    icon: "ri-bar-chart-2-line",
    title: t("Счётчики этапов"),
    text: t("Число и доля контактов на каждом этапе жизненного цикла — видно, где скапливаются лиды."),
  },
  {
    icon: "ri-inbox-line",
    title: t("Вкладки контактов"),
    text: t("Открытые, назначенные и неназначенные: сразу понятно, кто ждёт ответа и на кого ничего не закреплено."),
  },
  {
    icon: "ri-team-line",
    title: t("Нагрузка команды"),
    text: t("Сколько контактов закреплено за каждым участником и когда он был в сети."),
  },
];